import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/redux';
import { isRenderSupportInfoListPopup } from "../../../../store/blocks/infoCards/selectors";
import { SupportInfoListItem } from "../SupportInfoListItem";
var _SupportInfoListPopup = function _SupportInfoListPopup(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/React.createElement("div", {
    "data-t-id": "components-SupportInfoListPopup"
  }, items.map(function (card) {
    return /*#__PURE__*/React.createElement(SupportInfoListItem, _extends({
      key: card.type
    }, card));
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    shouldRender: isRenderSupportInfoListPopup(state)
  };
};
export var SupportInfoListPopup = compose(connect(mapStateToProps), withRenderFlag)(_SupportInfoListPopup);